<script lang="ts">
  import BottomPanel from '../BottomPanel.svelte'
  import CaptionCue from '../CaptionCue.svelte'
  import VodProgressBar from './VodProgressBar.svelte'
  import VodControlBar from './VodControlBar.svelte'
  import VodControlBarMobile from './VodControlBarMobile.svelte'
</script>

<BottomPanel>
  <CaptionCue />
  {#snippet progressBar()}
    <VodProgressBar />
  {/snippet}
  {#snippet controlBar()}
    <VodControlBar />
  {/snippet}
  {#snippet controlBarMobile()}
    <VodControlBarMobile />
  {/snippet}
</BottomPanel>
